/**
 * Main game config
 */
export var config = {
    // colors: ["#240046", "#70e000"],
    colors: ["#e63946", "#ffba08", "#c77dff", "#00b4d8", "#40916c", "#240046", "#70e000"],
    pos: [{ x: -1, y: 0 }, { x: 1, y: 0 }, { x: 0, y: -1 }, { x: 0, y: 1 }],
    destroyCount: 3,
    ballSpawnerCount: 3,
    fastGame: true,
    chanceForJoker: 0.1,
    board_length: 9,
    board_height: 9,
};
